import React from "react";
import { FormControl, AutoSuggest } from "../../Common";

export default (props) => (
    <FormControl>
        {/*<label>場地名稱：</label>*/}
        <AutoSuggest {...props} />
    </FormControl>
);
